/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxCardAccountsGetCardAccountTransactionsStatus = typeof UtxCardAccountsGetCardAccountTransactionsStatus[keyof typeof UtxCardAccountsGetCardAccountTransactionsStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxCardAccountsGetCardAccountTransactionsStatus = {
  declined: 'declined',
  pending: 'pending',
  posted: 'posted',
  void: 'void',
} as const;
